export const toCurrency = (number = 0, currency = 'Rp ') => {
  if (typeof number !== "number") return "-";

  if (typeof number === "number" && number > 0)
    return `${currency}${parseInt(number).toLocaleString("id-ID")}`;

  return `${currency}0`;
}
